




import {Vue, Component} from 'vue-property-decorator'

@Component({
  name: 'LayerPopView'
})
export default class LayerPopView extends Vue {
  protected isShow: boolean = false
  private container!: HTMLElement | null

  private mounted() {
    this.container = this.$refs.container as HTMLElement
    this.$eventBus.$on('LAYER-POP-OPEN', (component: Vue) => {
      this.open()
      if (this.container) {
        component.$mount()
        this.container.appendChild(component.$el)
      }
    })
    this.$eventBus.$on('LAYER-POP-CLOSE', () => {
      this.removeChild()
    })
  }

  private beforeDestroy() {
    this.$eventBus.$off('LAYER-POP-OPEN')
    this.$eventBus.$off('LAYER-POP-CLOSE')
  }

  private open(): void {
    if (!this.isShow) {
      this.isShow = true

      this.container!.setAttribute('style', 'display: block;')
      // this.container!.addEventListener('click', () => {
      //   this.close()
      // })
    }
  }
  private close(): void {
    if (this.isShow) {
      this.isShow = false

      this.container!.setAttribute('style', 'display: none;')
      // this.container!.removeEventListener('click', this.close)
    }
  }
  private removeChild(): void {
    if (this.container) {
      this.container.removeChild(this.container.childNodes[0])
      if (this.container.childNodes.length === 0) {
        this.close()
      }
    }
  }
}
